import React from "react";

const ImgIcon = ({ style = {}, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    enableBackground="new 0 0 20 20"
    fill="none"
    className={className}
    style={style}
  >
    <path
      d="M16.9883 15.2985C16.9883 15.4383 16.9417 15.5666 16.8368 15.6715C16.7319 15.7764 16.6153 15.823 16.4638 15.823H3.52456C3.38468 15.823 3.25645 15.7764 3.15154 15.6715C3.04663 15.5666 3 15.45 3 15.2985V4.7023C3 4.56241 3.04663 4.43419 3.15154 4.32927C3.25645 4.22436 3.37302 4.17773 3.52456 4.17773H16.4754C16.6153 4.17773 16.7435 4.22436 16.8485 4.32927C16.9534 4.43419 17 4.55076 17 4.7023V15.2985H16.9883ZM15.811 5.32012H4.17735V14.0628L7.73272 11.7431L8.22231 11.9646C8.54871 12.0928 8.96836 12.2793 9.46961 12.5241C9.97086 12.7689 10.3905 12.9904 10.7169 13.1886C10.8218 13.2585 10.9151 13.2935 10.985 13.2935C11.1832 13.3284 11.1249 13.0953 10.8218 12.5824C10.3439 11.8364 9.88926 11.3584 9.42298 11.1602C9.80766 10.7639 10.5304 9.97124 11.5795 8.80554L11.7427 8.66566C11.836 8.56075 11.9759 8.45584 12.1507 8.36258C12.3256 8.26932 12.5004 8.2227 12.6753 8.2227C13.025 8.2227 13.398 8.40921 13.7943 8.79389L15.811 10.8921V5.32012ZM6.49709 8.95708C6.84679 8.95708 7.13822 8.82886 7.39467 8.57241C7.65112 8.31595 7.77935 8.01287 7.77935 7.67482C7.77935 7.33677 7.65112 7.03369 7.40633 6.77723C7.16153 6.52078 6.85845 6.39256 6.48543 6.39256C6.11241 6.39256 5.82098 6.52078 5.56453 6.77723C5.30808 7.03369 5.19151 7.33677 5.19151 7.67482C5.19151 8.01287 5.31973 8.31595 5.57619 8.57241C5.83264 8.82886 6.13572 8.95708 6.47377 8.95708H6.49709Z"
      fill="#FFF"
    />
  </svg>
);

export default ImgIcon;
